import APIBase from "./apiBase";

export enum ExperienceStatus {
  ASSIGNED = "assigned",
  SHOWN = "shown",
  COMPLETED = "completed",
  DISMISSED = "dismissed",
}

export interface Experience {
  id: string;
  userId: string;
  slug: string;
  status: ExperienceStatus;
  assignedAt: string;
  shownAt: string | null;
  completedAt: string | null;
  dismissedAt: string | null;
}

export type ExperienceAction = "shown" | "completed" | "dismissed";

/**
 * Mark an experience with a specific action (shown, completed, or dismissed)
 */
export const markExperience = async (
  experienceId: string,
  action: ExperienceAction
): Promise<Experience> => {
  const { data } = await APIBase.post<Experience>(
    `/users/experiences/${experienceId}/action`,
    { action }
  );
  return data;
};

/**
 * Get all experiences for the current user
 */
export const getAll = async (): Promise<Experience[]> => {
  const { data } = await APIBase.get<Experience[]>("/users/experiences");
  return data;
};
